// extracted by mini-css-extract-plugin
export default {"headingContainer":"EditableHeading_headingContainer__5U96s","editButton":"EditableHeading_editButton__Wga53"};